import { Fragment, SetStateAction, useState } from 'react'
import { useParams } from 'react-router-dom'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import ModalEditCustomerProject from '../../../../ModalEditCustomerProject'
import { TableInstanceType } from '../../../../../../baseComponents/TwinTable/types'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { CustomerDashboardAddButton, CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import ModalCreateCustomerOpportunity from '../../../CustomerOpportunities/ModalCreateCustomerOpportunity'
import { TableCustomerOpportunitiesConnect } from '../../../CustomerOpportunities'
import { projectTypesInversed } from '@teinor/erp/types/company/customer/customerProject'

interface CustomerOpportunitiesDashboardProps extends CustomerOpportunitiesDashboardLogicProps { 
    title: string
    allRowData: CustomerModelType
}

const CustomerOpportunitiesDashboard: React.FC<CustomerOpportunitiesDashboardProps> = ({ title, allRowData }) => {
    const { t } = useTwinTranslation()
    const { tableInstance, setTableInstance } = useCustomerOpportunitiesDashboardLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const userPermissions = getUserPermissions('customer.profile.projects')
    return (
        <div className='flex flex-col flex-auto gap-10'>
            <div className='flex flex-wrap justify-between gap-5'>
                <div className='flex items-center gap-x-10'>
                    <h3>{title}</h3>
                    <CustomerDashboardSeeAllLink customerTab='opportunities' customerType={allRowData?.customer_type} />
                </div>
                <CustomerDashboardAddButton CreateModalComponent={ModalCreateCustomerOpportunity} onSubmit={updateTableInstance} userPermissions={userPermissions || { n: 4, permission: 'delete' }} text={t('newOportunity', 'Nueva oportunidad')} />
            </div>
            <TableCustomerOpportunitiesDashboard userPermissions={userPermissions || { n: 4, permission: 'delete' }} onSubmit={updateTableInstance} setTableInstance={setTableInstance} tableInstance={tableInstance} />
        </div>
    )
}

interface CustomerOpportunitiesDashboardLogicProps {}

const useCustomerOpportunitiesDashboardLogic = () => {
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    return { setTableInstance, tableInstance }
}

interface TableCustomerOpportunitiesDashboardProps extends ComponentWithPermissions {
    onSubmit: OnSubmit
    setTableInstance: React.Dispatch<SetStateAction<TableInstanceType>>
    tableInstance: TableInstanceType
}

const TableCustomerOpportunitiesDashboard: React.FC<TableCustomerOpportunitiesDashboardProps> = ({ onSubmit, setTableInstance, userPermissions, tableInstance }) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <TableCustomerOpportunitiesConnect name='CustomerOpportunitiesDashboard' hideLoadFiltersButton={true} className='small_simple_table' extraWhereParams={{ CustomerId: id, projectType: projectTypesInversed['opportunity'] }} setTableInstance={setTableInstance} setOpened={setOpenModal} tableInstance={tableInstance} userPermissions={userPermissions} />
            {openModal?.type === 'edit' && <ModalEditCustomerProject {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} userPermissions={userPermissions} allRowData={openModal?.allRowData} basicData={{}} />}
        </Fragment>
    )
}

export default CustomerOpportunitiesDashboard